var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./ProductionDesignInitiativeApplicationSuccess.jinja');
require('./ProductionDesignInitiativeApplicationSuccess.less');


module.exports = Base.extend({

    template: template,

    events: {
        'click .ProductionDesignInitiativeApplicationSuccess-okButton': 'onOkClick',
        'click': 'onBGClick'
    },


    initialize: function (options) {

        _.bindAll(this, 'onKeyDown');

        Base.prototype.initialize.call(this, options);
    },


    show: function (params) {
        params = params || {};

        $('body').on('keydown', this.onKeyDown);

        this.cb = params.cb;
        this.$el.addClass('ProductionDesignInitiativeApplicationSuccess--visible');
    },


    hide: function () {
        $('body').off('keydown', this.onKeyDown);

        this.$el.removeClass('ProductionDesignInitiativeApplicationSuccess--visible');
    },


    onBGClick: function (e) {
        if ($(e.target).closest('.ProductionDesignInitiativeApplicationSuccess-body').length) return;

        this.onOkClick();
    },

    onKeyDown: function (e) {
        if (e.keyCode == 27) { //esc
            e.stopPropagation();

            this.onOkClick();
        }
    },


    onOkClick: function () {
        this.hide();

        this.cb && this.cb(true);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/ProductionDesignInitiativeApplicationSuccess/ProductionDesignInitiativeApplicationSuccess.js
// module id = 236
// module chunks = 0